// Authorization
export const PURGE_AUTH = 'logout'
export const SET_AUTH = 'setAuthentication'

// Languages
export const SET_LANGUAGE = 'setLanguage'

// Dashboard
export const SET_DASHBOARD_STATS = 'setDashboardStats'

// Chargers
export const SET_CHARGERS = 'setChargers'

// Media
export const SET_DEFAULT_MEDIA = 'setDefaultMedia'
export const SET_MEDIA = 'setMedia'
export const SET_NEW_UPLOAD_KEY = 'setNewUploadKey'
export const SET_NEW_UPLOAD_IMAGE = 'setNewUploadImage'
export const SET_PLATFORM = 'setPlatform'
export const TOGGLE_TAGS_CHECKED = 'toggleTagChecked'
export const SET_MEDIA_NAME = 'setMediaName'
export const SET_MEDIA_DATES = 'setMediaDates'
export const SET_UPLOAD_TAGS = 'setUploadTags'
export const SET_SCREEN_STATE = 'setScreenState'
export const SET_DETAILS = 'setDetails'
export const SET_ACTIVE_MEDIA_ID = 'setActiveMediaID'
export const RESET_ACTIVE_MEDIA = 'resetActiveMedia'
export const SET_ACTIVE_MEDIA = 'setActiveMedia'
export const SET_CRITERIA = 'setCriteria'
export const SET_CRITERIA_LOADED = 'setCriteriaLoaded'
export const SET_TAG_VALUES = 'setTagValues'
export const REMOVE_MEDIA_ITEM = 'removeMediaItem'
export const LOAD_DEFAULT_MEDIA = 'loadDefaultMedia'
export const SET_COUNTRY = 'setCountry'

// Partners
export const SET_PARTNERS = 'setPartners'

// Users
export const SET_USERS = 'setUsers'

// Sky Objects
export const SET_SKY_OBJECTS = 'setSkyObjects'